import script from "./AppealLetterSection.vue?vue&type=script&setup=true&lang=js"
export * from "./AppealLetterSection.vue?vue&type=script&setup=true&lang=js"

import "./AppealLetterSection.vue?vue&type=style&index=0&id=854b1a74&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-854b1a74"]])

export default __exports__